/**
 * RAC 標準のカレンダー操作をするクラス
 */
import * as time from '@/libs/time'
import Calendar from './base'

export default class StandardCalendar extends Calendar {
  /**
   * 予約開始日時にインターバル時間を確保する
   *
   * @param {Date} d 元の予約開始日時
   * @param {Number} intervalHours インターバル時間
   * @returns {Date} 予約開始日時を返す
   */
  securedBegin (d, intervalHours) {
    d.setTime(d.getTime() - (intervalHours * time.HOUR))
    if (d < this._begin) {
      d.setTime(this._begin.getTime())
    }
    return d
  }

  /**
   * 予約終了日時にインターバル時間を確保する
   *
   * @param {Date} d 元の予約終了日時
   * @param {Number} intervalHours インターバル時間
   * @returns {Date} 予約終了日時を返す
   */
  securedEnd (d, intervalHours) {
    d.setTime(d.getTime() + (intervalHours * time.HOUR))
    if (this._end < d) {
      d.setTime(this._end.getTime())
    }
    return d
  }
}
